import axios from 'axios'

export const validateForm = (pageId, body, purchaseProcessId) => {
  return axios.post(
    `/secure/paypal/soap/${pageId}/validate-form-and-store-customer-data/${purchaseProcessId}`,
    {
      payment_form: body,
    },
  )
}

export const purchaseDetails = (pageId, body, purchaseProcessId) => {
  return axios.post(
    `/secure/paypal/soap/${pageId}/purchase-details/${purchaseProcessId}`,
    {
      offer_payment: body,
    },
  )
}
